<div class="row wrapper border-bottom white-bg page-heading">
  <div class="col-lg-10">
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <a [routerLink]="['/home']">Home</a>
      </li>
      <li class="breadcrumb-item">
        <a>Geo Assets</a>
      </li>
    </ol>
  </div>
</div>


<div class="wrapper wrapper-content animated fadeInRight">
  <div class="row">
    <div class="col-lg-12">
      <div class="card mt-2">
        <div class="card-body">
          <div class="d-flex fw-bold small mb-3">
            <span class="flex-grow-1">
              <button (click)="clearAsset();updateItemModal.show()" class="btn btn-outline-default">Add New Geo
                Asset</button>
              <button (click)="typesModal.show()" class="btn btn-outline-default ms-2">Manage Types</button>
            </span>
          </div>
          
          <!-- Search and Filters -->
          <div class="row mt-2">
            <div class="col-lg-12">
              <div class="form-group form-group-sm mt-2 btn-group btn-block">
                <input type="text" placeholder="Search geo assets by name or identifier..." 
                  class="form-control form-control-sm" [(ngModel)]="searchFilter" 
                  (input)="onInput($event)" (keyup.enter)="doSearch()">
                <button type="button" class="btn btn-sm btn-outline-default" 
                  (click)="doSearch()" [disabled]="loading">
                  <i class="fa fa-search"></i>
                </button>
              </div>

              <div class="d-flex fw-bold small mt-2">
                <span class="flex-grow-1">
                  <pagination class="float-sm-left" [totalItems]="totalItems" [(ngModel)]="pageIndex" 
                    (pageChanged)="pageChange($event)" [disabled]="loading" [maxSize]="maxPages" size="sm">
                  </pagination>
                </span>
                <span>
                  <div class="btn-group form-group-sm me-2" dropdown [isDisabled]="loading">
                    <button id="button-type-filter" dropdownToggle type="button" 
                      class="btn btn-outline-default btn-sm dropdown-toggle" aria-controls="dropdown-type-filter">
                      Type: {{ selectedTypeFilter ? getTypeName(selectedTypeFilter) : 'All' }}
                    </button>
                    <ul id="dropdown-type-filter" *dropdownMenu class="dropdown-menu" role="menu" 
                      aria-labelledby="button-type-filter">
                      <li role="menuitem"><a class="dropdown-item" (click)="filterByType(null)">All Types</a></li>
                      <li role="menuitem" *ngFor="let type of geoAssetTypes">
                        <a class="dropdown-item" (click)="filterByType(type.id)">{{type.name}}</a>
                      </li>
                    </ul>
                  </div>
                  <div class="btn-group form-group-sm float-sm-right filter-button" dropdown [isDisabled]="loading">
                    <button id="button-basic" dropdownToggle type="button" 
                      class="btn btn-outline-default btn-sm dropdown-toggle" aria-controls="dropdown-basic">
                      Page Size: {{pageSize}}
                    </button>
                    <ul id="dropdown-basic" *dropdownMenu class="dropdown-menu" role="menu" 
                      aria-labelledby="button-basic">
                      <li role="menuitem"><a class="dropdown-item" (click)="setPageSize(10)">10</a></li>
                      <li role="menuitem"><a class="dropdown-item" (click)="setPageSize(50)">50</a></li>
                      <li role="menuitem"><a class="dropdown-item" (click)="setPageSize(100)">100</a></li>
                      <li role="menuitem"><a class="dropdown-item" (click)="setPageSize(200)">200</a></li>
                    </ul>
                  </div>
                </span>
              </div>
            </div>
          </div>

          <table class="table table-striped mt-3">
            <thead>
              <tr>
                <th scope="col" style="width: 60px;">#
                  <i (click)="columnSort('id')" class="{{columnSortStyle('id')}}"></i>
                </th>
                <th scope="col" class="d-none d-lg-table-cell" style="width: 150px;">Identifier
                  <i (click)="columnSort('identifier')" class="{{columnSortStyle('identifier')}}"></i>
                </th>
                <th scope="col" style="width: 200px;">Name
                  <i (click)="columnSort('name')" class="{{columnSortStyle('name')}}"></i>
                </th>
                <th scope="col" class="d-none d-xl-table-cell">Description</th>
                <th scope="col" class="d-none d-lg-table-cell" style="width: 150px;">Type
                  <i (click)="columnSort('geoAssetTypeId')" class="{{columnSortStyle('geoAssetTypeId')}}"></i>
                </th>
                <th scope="col" class="d-none d-lg-table-cell" style="width: 120px;">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngIf="(geoAssets == null || geoAssets.length == 0) && !loading">
                <td scope="row" colspan="6" class="text-center">No Geo Assets Found</td>
              </tr>
              <tr *ngIf="(geoAssets == null || geoAssets.length == 0) && loading">
                <td scope="row" colspan="6" class="text-center">Loading...</td>
              </tr>
              <tr *ngFor="let asset of geoAssets">
                <td><a href="javascript:void(0)" (click)="editAsset(asset)" class="text-primary">{{ asset.id }}</a></td>
                <td class="d-none d-lg-table-cell">{{ asset.identifier }}</td>
                <td>{{ asset.name }}</td>
                <td class="d-none d-xl-table-cell">{{ asset.description }}</td>
                <td class="d-none d-lg-table-cell">{{ getTypeName(asset.geoAssetTypeId) }}</td>
                <td class="d-none d-lg-table-cell">
                  <!-- edit -->
                  <a class="btn btn-outline-default" (click)="editAsset(asset)"><i class="fa fa-pencil"></i></a>
                  <!-- delete -->
                  &nbsp;
                  <a class="btn btn-outline-danger ml-2" (click)="removeAsset(asset)"><i class="fa fa-trash"></i></a>
                </td>
              </tr>

            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>


<div class="modal fade" bsModal #updateItemModal="bs-modal" [config]="{backdrop: 'static'}" (onShown)="onModalShown()"
  tabindex="-1" role="dialog" aria-labelledby="dialog-static-name">
  <div class="modal-dialog modal-lg">
    <div class="modal-content" *ngIf="currentAsset">
      <div class="modal-header">
        <h5 class="modal-title">Update Item : {{currentAsset.name}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="updateItemModal.hide()"></button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-sm-6">
            <div class="form-group input-group-sm">
              <label>Identifier</label>
              <div class="input-group m-b">
                <input type="text" [(ngModel)]="currentAsset.identifier" class="form-control" />
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group input-group-sm">
              <label>Name</label>
              <div class="input-group m-b">
                <input type="text" [(ngModel)]="currentAsset.name" class="form-control" />
              </div>
            </div>
          </div>
          <div class="col-sm-12">
            <div class="form-group input-group-sm">
              <label>Description</label>
              <div class="input-group m-b">
                <textarea [(ngModel)]="currentAsset.description" class="form-control" rows="3"></textarea>
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group input-group-sm">
              <label>Type</label>
              <div class="input-group m-b">
                <select [(ngModel)]="currentAsset.geoAssetTypeId" class="form-control form-select">
                  <option [ngValue]="null">-- Select Type --</option>
                  <option *ngFor="let type of geoAssetTypes" [ngValue]="type.id">{{type.name}}</option>
                </select>
              </div>
            </div>
          </div>
          <div class="col-sm-12">
            <div class="form-group">
              <label>Geometry</label>
              <app-geo-asset-editor #geoEditor [geoAsset]="currentAsset"></app-geo-asset-editor>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button (click)="updateItemModal.hide()" class="btn btn-white">Cancel</button>
          <button *ngIf="currentAsset.id" (click)="updateAsset();updateItemModal.hide()"
            class="btn btn-primary">Update</button>
          <button *ngIf="!currentAsset.id" (click)="addAsset();updateItemModal.hide()"
            class="btn btn-primary">Add</button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Geo Asset Types Modal -->
<div class="modal fade" bsModal #typesModal="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1" role="dialog"
  aria-labelledby="dialog-types-name">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Manage Geo Asset Types</h4>
        <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="typesModal.hide()"></button>
      </div>
      <div class="modal-body">
        <div class="mb-3">
          <button (click)="addNewTypeRow()" class="btn btn-sm btn-primary">Add New Type</button>
        </div>
        <table class="table table-sm table-striped">
          <thead>
            <tr>
              <th style="width: 80px;">ID</th>
              <th style="width: 200px;">Name</th>
              <th>Description</th>
              <th style="width: 180px;">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let type of geoAssetTypes">
              <td>
                <span *ngIf="type.id >= 0">{{ type.id }}</span>
                <span *ngIf="type.id < 0" class="text-muted"><em>New</em></span>
              </td>
              <td>
                <input *ngIf="editingTypeId === type.id" type="text" [(ngModel)]="type.name" 
                  class="form-control form-control-sm" placeholder="Type name" />
                <span *ngIf="editingTypeId !== type.id">{{ type.name }}</span>
              </td>
              <td>
                <input *ngIf="editingTypeId === type.id" type="text" [(ngModel)]="type.description" 
                  class="form-control form-control-sm" placeholder="Description" />
                <span *ngIf="editingTypeId !== type.id">{{ type.description }}</span>
              </td>
              <td>
                <div *ngIf="editingTypeId !== type.id">
                  <button (click)="editType(type)" class="btn btn-sm btn-outline-primary">Edit</button>
                </div>
                <div *ngIf="editingTypeId === type.id">
                  <button (click)="saveType(type)" class="btn btn-sm btn-success me-1">Save</button>
                  <button (click)="cancelEditType(type)" class="btn btn-sm btn-secondary">Cancel</button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="modal-footer">
        <button (click)="typesModal.hide()" class="btn btn-white">Close</button>
      </div>
    </div>
  </div>
</div>